// extracted by mini-css-extract-plugin
export default {"cls1":"SubmittedErrorDetails-ErrorBar_cls1__m0M56","cls2":"SubmittedErrorDetails-ErrorBar_cls2__7CVfZ SubmittedErrorDetails-ErrorBar_cls1__m0M56"};